import { render, staticRenderFns } from "./EventForm.vue?vue&type=template&id=3503c3a8&scoped=true&"
import script from "./EventForm.vue?vue&type=script&lang=ts&"
export * from "./EventForm.vue?vue&type=script&lang=ts&"
import style0 from "./EventForm.vue?vue&type=style&index=0&id=3503c3a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3503c3a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3503c3a8')) {
      api.createRecord('3503c3a8', component.options)
    } else {
      api.reload('3503c3a8', component.options)
    }
    module.hot.accept("./EventForm.vue?vue&type=template&id=3503c3a8&scoped=true&", function () {
      api.rerender('3503c3a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AddLossModal/EventForm.vue"
export default component.exports